export const getSetupStepData = ({ eFileSetupStepsData = null, action }) =>
  eFileSetupStepsData?.find(({ stepName }) => stepName === action);
